<template>
    <div>
        <Spin fix v-if="loading"></Spin>
        <field-group
            :rules="feeRule"
            v-for="(item, index) in feeList"
            :key="index"
            :model="item"
            :viewonly="isView"
        >
            <Row :gutter="20" style="margin-bottom: 20px">
                <Col span="6">
                    <form-item style="display: none" prop="repairId">
                        <Input v-model="item.repairId"></Input>
                    </form-item>
                    <form-item prop="repairFeeType">
                        <Select
                            v-model="item.repairFeeType"
                            placeholder="请选择"
                            style="width: 150px"
                        >
                            <Option
                                v-for="o in dict.repairFeeType.toList()"
                                :value="o.id"
                                :key="o.id"
                            >
                                {{ o.text }}
                            </Option>
                        </Select>
                    </form-item>
                </Col>
                <Col span="6">
                    <form-item prop="amount">
                        <input-number
                            v-model="item.amount"
                            :min="0"
                            style="width: 150px"
                            placeholder="金额"
                        >
                        </input-number>
                    </form-item>
                </Col>
                <Col span="10">
                    <form-item prop="remark">
                        <Input
                            v-model="item.remark"
                            style="width: 265px"
                            placeholder="备注"
                        />
                    </form-item>
                </Col>
                <Col span="2">
                    <Icon
                        style="cursor: pointer"
                        type="ios-close"
                        size="26"
                        @click="remove(index)"
                    />
                </Col>
            </Row>
        </field-group>
        <div v-if="!isView" class="fee-add" @click="add()">
            <span class="fee-add-plus">+</span>添加费用
        </div>
    </div>
</template>

<script>
import { Field } from 'ivux'
import Dict from '_u/dict'

export default {
    props: {
        repairId: [Number, String],
        feeList: Array,
        isView: Boolean,
        populateType: {
            type: String,
            default: 'chain',
        },
    },
    mixins: [Field],
    data() {
        return {
            loading: false,
            dict: {
                repairFeeType: this.$dict.NULL,
            },
        }
    },
    computed: {
        feeRule() {
            return {
                repairFeeType: [{ required: true, message: '必填' }],
                amount: [{ required: true, message: '必填' }],
            }
        },
    },
    mounted() {
        // this.feeList.length === 0
        //     ? this.feeList.push(this.createFeeItem())
        //     : undefined
        this.fetch()
            .then((r) => {})
            .finally(() => {
                this.loading = false
            })
    },
    methods: {
        fetch() {
            this.loading = true
            return Promise.all([this.$dict.get(['repair_fee_type'])]).then(
                (r) => {
                    const [group] = r
                    Object.assign(this.dict, group)
                }
            )
        },
        add() {
            this.feeList.push(this.createFeeItem())
        },
        createFeeItem() {
            return {
                repairId: this.repairId,
                repairFeeType: '',
                amount: '',
                remark: '',
            }
        },
        remove(i) {
            this.feeList.splice(i, 1)
        },
    },
}
</script>

<style lang="less" scoped>
.remove-icon {
    display: inline-block;
    cursor: pointer;
    line-height: 0;
    font-size: 18px;
    padding: 14px 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    background: #fff;
}

.fee {
    &-add {
        display: inline-block;
        cursor: pointer;
        line-height: 14px;

        &-plus {
            line-height: 12px;
            padding: 0 2px;
            margin-right: 2px;
            display: inline-block;
            border: 1px solid #ccc;
            border-radius: 4px;
            background: #fff;
        }
    }
}
</style>
